import { WorkerSummary } from "../../Models/Workers/Workers";
import {
  WorkersActionSetInitialized,
  WorkersActionSetWorkers,
  WorkersActionsTypes,
} from "./typings/WorkersActionsTypes";

export class WorkersActions {
  static setWorkersInitialized = (initialized: boolean): WorkersActionSetInitialized => ({
    type: WorkersActionsTypes.SET_WORKERS_INITIALIZED,
    payload: { initialized },
  });

  static setWorkers = (items: Array<WorkerSummary>): WorkersActionSetWorkers => ({
    type: WorkersActionsTypes.SET_WORKERS,
    payload: { items },
  });

  static setNewPassword = (code: string) => ({
    type: WorkersActionsTypes.SET_NEW_PASSWORD,
    payload: { code },
  });
}
